/*
 * Comportamientos de las secciones Dom Pérignon.
 * ---------------------------------------------------------------------------
 * Un único listener delegado en document en vez de uno por galería: así las
 * secciones que Shopify vuelve a renderizar en el editor de temas siguen
 * funcionando sin re-inicializar nada.
 */
(function () {
  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  document.addEventListener('click', function (e) {
    var thumb = closest(e.target, '[data-dp-thumb]');
    if (!thumb) return;

    var root = closest(thumb, '[data-dp-gallery]');
    if (!root) return;

    var main = root.querySelector('[data-dp-main]');
    var src = thumb.getAttribute('data-dp-src');
    if (!main || !src) return;

    var label = thumb.getAttribute('data-dp-alt');

    if (main.tagName === 'IMG') {
      // srcset primero: si se setea despues de src, el navegador puede llegar
      // a pedir el src suelto antes de evaluar el set y bajar dos archivos.
      var srcset = thumb.getAttribute('data-dp-srcset');
      if (srcset) main.setAttribute('srcset', srcset);
      else main.removeAttribute('srcset');
      main.src = src;
      // La imagen ya esta en viewport cuando alguien clickea una miniatura:
      // dejarla en lazy solo demora el swap.
      main.loading = 'eager';
      if (label) main.alt = label;

      // Con <picture>, el <source> mobile gana siempre sobre el src del <img>:
      // si no se actualiza acá, en mobile las miniaturas no cambian nada.
      var mobileSource = root.querySelector('[data-dp-main-source]');
      if (mobileSource) {
        mobileSource.setAttribute(
          'srcset',
          thumb.getAttribute('data-dp-srcset-mobile') || srcset || src
        );
      }
    } else {
      main.style.backgroundImage = "url('" + src + "')";
      if (label) main.setAttribute('aria-label', label);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-dp-thumb]'), function (b) {
      var on = b === thumb;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-current', on ? 'true' : 'false');
    });
  });

  /* Scroll suave hacia la sección anclada.
   * El salto en seco del ancla nativa hace perder el hilo de dónde quedó uno
   * en la página. scrollIntoView respeta el scroll-margin-top que ya tienen
   * las secciones, así que el header no pisa el título al aterrizar.
   */
  document.addEventListener('click', function (e) {
    var link = closest(e.target, '[data-dp-scroll]');
    if (!link) return;

    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;

    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    e.preventDefault();

    var reduce = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

    // El foco tiene que seguir al scroll o quien navega con teclado sigue
    // parado arriba. preventScroll para no anular la animación recién lanzada.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    if (window.history && history.replaceState) history.replaceState(null, '', hash);
  });
})();
